/**
 * @file tonnageAdditionActions.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-23
 * @modified 2026-10-23
 * @description "Add to another order…" / "Added tonnage…" as a row-menu action
 *              — Search Customer Orders and the order window. The rule is
 *              utils/tonnageAdditions.addToOrderAction; this adds who the user
 *              is (Edit sales orders; a view-only account greyed) — the server
 *              checks the same. Client only (it reads permissions), so not in
 *              the shared copy.
 */

import { hasPermission, isReadOnly } from './permissions';
import { addToOrderAction, ADD_TO_ORDER_LABEL, ADDED_TONNAGE_LABEL } from './tonnageAdditions';

/** May this user add a split's tonnage to another order? */
export const canAddTonnage = (user) => hasPermission(user, 'orders.edit');

/** What the action does for this order and user: { mode, block }. */
export function addToOrderActionFor(order, user) {
  return addToOrderAction(order, {
    ready: order?.tonnage_additions_ready !== false,
    canEdit: canAddTonnage(user),
    readOnly: isReadOnly(user)
  });
}

/** The menu action object for a row; `open(orderId)` opens AddToOrderModal. */
export function addToOrderMenuAction(order, user, open) {
  const { mode, block } = addToOrderActionFor(order, user);
  const id = order?.id;
  return {
    key: 'add-to-order',
    icon: 'call_merge',
    label: mode === 'view' ? ADDED_TONNAGE_LABEL : ADD_TO_ORDER_LABEL,
    // Viewing what it shares is read-safe; taking it out is checked in the window.
    readSafe: mode === 'view',
    disabled: !!block || !id,
    title: block || (mode === 'view'
      ? `What ${order.order_number || 'the order'} shares with the customer's other order — take it back out there`
      : `Invoice ${order.order_number || 'this split'}'s tonnage on the customer's other order that day — one invoice, one line`),
    onClick: () => { if (!block && id) open(id); }
  };
}
